<template>
  <el-dialog
    title="修改密码"
    :visible.sync="visibleDialog"
    :close-on-click-modal="false"
    :modal-append-to-body="false"
    width="30%"
  >
    <el-form ref="rowForm" :model="row" :rules="rules" label-width="100px">
      <el-form-item label="原密码" prop="passwordOld">
        <el-input v-model="row.passwordOld" type="password" autocomplete="off" show-password/>
      </el-form-item>
      <el-form-item label="新密码" prop="passwordNew">
        <el-input v-model="row.passwordNew" type="password" autocomplete="off" show-password/>
      </el-form-item>
      <el-form-item label="确认新密码" prop="passwordConfirm">
        <el-input v-model="row.passwordConfirm" type="password" autocomplete="off" show-password/>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="handleCancel">取消</el-button>
      <el-button type="primary" :loading="btnSaveLoading" @click="handleSave">保存</el-button>
    </div>
  </el-dialog>
</template>

<script>

import { changePassword } from "@/api/api";

export default {
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      btnSaveLoading: false,
      row: {
        passwordOld: null,
        passwordNew: null,
        passwordConfirm: null
      },
      rules: Object.freeze({
        passwordOld: [
          {required: true, message: '请输入原密码', trigger: 'blur'},
          {min: 1, max: 32, message: '长度必须在 1 - 32 之间，且包含大写字母、小写字母、数字和特殊字符', trigger: 'blur'},
        ],
        passwordNew: [
          {required: true, message: '请输入密码', trigger: 'blur'},
          {min: 8, max: 32, message: '长度必须在 8 - 32 之间，且包含大写字母、小写字母、数字和特殊字符', trigger: 'blur'},
        ],
        passwordConfirm: [
          {required: true, message: '请输入密码', trigger: 'blur'},
          {min: 8, max: 32, message: '长度必须在 8 - 32 之间，且包含大写字母、小写字母、数字和特殊字符', trigger: 'blur'},
          {
            trigger: 'blur',
            validator: (rule, value, callback) => {
              if (!value) {
                callback()
              }
              if (value === this.row.passwordNew) {
                if (/^(?=.*[A-Z])(?=.*[a-z])(?=.*\\d)(?=.*[^A-Za-z0-9]).{8,32}$/.test(value)) {
                  callback(new Error('长度必须在 8 - 32 之间，且包含大写字母、小写字母、数字和特殊字符'))
                }
                callback()
              } else {
                callback(new Error('两次输入密码不一致'))
              }
            }
          }
        ]
      })
    }
  },
  computed: {
    visibleDialog: {
      get() {
        return this.visible
      },
      set(val) {
        this.$emit('update:visible', val)
      }
    }
  },
  methods: {
    handleCancel() {
      this.$refs.rowForm.resetFields()
      this.visibleDialog = false
    },
    async handleSave() {
      const valid = await this.$refs.rowForm.validate()
      if (!valid) {
        return
      }
      this.btnSaveLoading = true
      const result = await changePassword(this.row.passwordOld, this.row.passwordNew).finally(() => (this.btnSaveLoading = false))
      if (result.code === 'A00000') {
        this.$message.success('密码修改成功')
        this.handleCancel()
        this.$emit('ok')
      } else {
        this.$message.error(`密码修改失败：${result.message}`)
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/UserChangePasswordDialog.vue